module.exports = __webpack_public_path__ + "img/metabolize_intro.99479e4b.jpg";